import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import { getPersonFullName } from "utils/person";

const ABC_LIST = "ABC List";

export const getExamNoteCreatorName = (user: racehorse360.IUser): string => {
  if (!user) return ABC_LIST;

  return getPersonFullName(user, "%f %m %L");
};
